var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo } from "react";
import { Button, Layout, Select } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { useIntl } from "react-intl";
import { navigation } from "./navigation";
import { hasAtLeastOneRole, useActiveRoles } from "../utils/permissionsUtils";
import { useCanRequestCopies } from "../hooks/useCanRequestCopies";
import { ROUTE_PATHS } from "../types/routePaths";
import { RoleEnum } from "../types/RoleEnum";
import { fetchLibraries } from "../api/libraryService";
import { setViewAsLibrary, clearViewAsLibrary } from "../utils/viewAsLibrary";
import { useViewAsLibraryId } from "../hooks/useViewAsLibraryId";
import styles from "./NavComponent.module.css";
var NavigationComponent = function () {
    var _a;
    var history = useHistory();
    var pathname = useLocation().pathname;
    var activeRoles = useActiveRoles();
    var canRequestCopies = useCanRequestCopies().canRequestCopies;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var formatMessage = useIntl().formatMessage;
    var isSuperUser = activeRoles && activeRoles.includes(RoleEnum.SUPERUSER);
    var selectedLibraryId = (_a = useViewAsLibraryId()) !== null && _a !== void 0 ? _a : "";
    var _b = useQuery(["nav-view-as-libraries"], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchLibraries(kyInstance, {
                        limit: 100,
                        offset: 0,
                    })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, ((_a = response.items) !== null && _a !== void 0 ? _a : [])
                            .sort(function (a, b) {
                            var _a, _b, _c, _d;
                            var countDiff = ((_a = b.nonPeriodicalsCountAllRegions) !== null && _a !== void 0 ? _a : 0) -
                                ((_b = a.nonPeriodicalsCountAllRegions) !== null && _b !== void 0 ? _b : 0);
                            return countDiff !== 0
                                ? countDiff
                                : ((_c = a.name) !== null && _c !== void 0 ? _c : "").localeCompare((_d = b.name) !== null && _d !== void 0 ? _d : "", "cs");
                        })
                            .map(function (lib) {
                            var _a, _b;
                            return ({
                                value: (_a = lib.id) !== null && _a !== void 0 ? _a : "",
                                label: (_b = lib.name) !== null && _b !== void 0 ? _b : "",
                            });
                        })];
            }
        });
    }); }, { enabled: !!isSuperUser }).data, libraryOptions = _b === void 0 ? [] : _b;
    var handleLibraryChange = useCallback(function (e) {
        var _a;
        var libraryId = e.target.value;
        if (!libraryId) {
            clearViewAsLibrary();
        }
        else {
            var library = libraryOptions.find(function (l) { return l.value === libraryId; });
            setViewAsLibrary(libraryId, (_a = library === null || library === void 0 ? void 0 : library.label) !== null && _a !== void 0 ? _a : "");
        }
        queryClient.invalidateQueries();
    }, [libraryOptions, queryClient]);
    var allowedRoutes = useMemo(function () {
        return Object.values(navigation).filter(function (route) {
            if (route.roles && !hasAtLeastOneRole(activeRoles, route.roles)) {
                return false;
            }
            if (route.path === ROUTE_PATHS.REQUESTABLE_TITLES && !canRequestCopies) {
                return false;
            }
            return true;
        });
    }, [activeRoles, canRequestCopies]);
    var handleClick = useCallback(function (path) {
        if (pathname !== path)
            history.push(path);
    }, [history, pathname]);
    return (React.createElement(Layout, { className: "padding-start-gutter padding-end-gutter" },
        React.createElement("div", { style: {
                backgroundColor: "#f5f5f5",
                padding: "1rem",
                borderRadius: "4px",
            } },
            React.createElement("h3", { style: { fontWeight: "bold", marginBottom: "1rem" } }, "Navigace"),
            React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "1rem" } }, allowedRoutes.map(function (route, index) {
                var isActive = pathname === route.path;
                return (React.createElement(React.Fragment, { key: route.path },
                    index > 0 && route.sectionStart && (React.createElement("div", { className: styles.sectionDivider })),
                    React.createElement(Button, { onClick: function () { return handleClick(route.path); }, buttonStyle: isActive ? "primary" : "default", fullWidth: true, marginBottom0: true, style: { justifyContent: "flex-start" }, "aria-current": isActive ? "page" : undefined },
                        React.createElement("span", { style: { marginLeft: "0.5rem" } }, route.label))));
            })),
            isSuperUser && libraryOptions.length > 0 && (React.createElement("div", { className: styles.viewAsSection },
                React.createElement(Select, { label: formatMessage({
                        id: "ui-br-legaldeposits.navigation.viewAsLibrary",
                    }), value: selectedLibraryId, onChange: handleLibraryChange, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-legaldeposits.navigation.viewAsLibrary.global",
                            }),
                        }
                    ], libraryOptions, true) }))))));
};
export default NavigationComponent;
